import { c as _c } from "react/compiler-runtime";
import { numberWithCommas } from "@/helpers/Helpers";
import type { LabNFT, NFT } from "@/entities/INFT";
import { MetadataLink } from "./MetadataLink";
export function NftPageStats(props) {
  const $ = _c(21);
  const hasHodlRate = !props.hide_hodl_rate && "hodl_rate" in props.nft;
  let t0;
  if ($[0] !== props.hide_mint_price || $[1] !== props.nft.mint_price) {
    t0 = !props.hide_mint_price && <NftStatTableRow label="Mint Price" value={props.nft.mint_price} decimals={100000} unit="ETH" />;
    $[0] = props.hide_mint_price;
    $[1] = props.nft.mint_price;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== props.nft.uri) {
    t1 = <MetadataLink url={props.nft.uri} />;
    $[3] = props.nft.uri;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== hasHodlRate || $[6] !== props.nft.hodl_rate) {
    t2 = hasHodlRate && <NftStatTableRow label="TDH Rate" value={props.nft.hodl_rate} decimals={100} />;
    $[5] = hasHodlRate;
    $[6] = props.nft.hodl_rate;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== props.nft.floor_price) {
    t3 = <NftStatTableRow label="Floor Price" value={props.nft.floor_price} unit="ETH" />;
    $[8] = props.nft.floor_price;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== props.nft.market_cap) {
    t4 = <NftStatTableRow label="Market Cap" value={props.nft.market_cap} decimals={100} unit="ETH" />;
    $[10] = props.nft.market_cap;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== props.nft.highest_offer) {
    t5 = <NftStatTableRow label="Highest Offer" value={props.nft.highest_offer} unit="ETH" />;
    $[12] = props.nft.highest_offer;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t0 || $[15] !== t1 || $[16] !== t2 || $[17] !== t3 || $[18] !== t4 || $[19] !== t5) {
    t6 = <>{t0}{t1}{t2}{t3}{t4}{t5}</>;
    $[14] = t0;
    $[15] = t1;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
}
function NftStatTableRow(props) {
  const $ = _c(10);
  const decimals = props.decimals ?? 1000;
  const value = Math.round(props.value * decimals) / decimals;
  let t0;
  if ($[0] !== props.label) {
    t0 = <td>{props.label}</td>;
    $[0] = props.label;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.unit || $[3] !== value) {
    t1 = value > 0 ? `${numberWithCommas(value)} ${props.unit ?? ""}` : "N/A";
    $[2] = props.unit;
    $[3] = value;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <td><b>{t1}</b></td>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t0 || $[8] !== t2) {
    t3 = <tr>{t0}{t2}</tr>;
    $[7] = t0;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}